import { render } from "./ParticipantsView.vue?vue&type=template&id=c0274bf2&scoped=true"
import script from "./ParticipantsView.vue?vue&type=script&lang=js"
export * from "./ParticipantsView.vue?vue&type=script&lang=js"

import "./ParticipantsView.vue?vue&type=style&index=0&id=c0274bf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0274bf2"]])

export default __exports__